import { Col, Row, FormControl, Pagination } from "react-bootstrap";
import "./jobs.css";
import Tab from "react-bootstrap/Tab";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Tabs from "react-bootstrap/Tabs";
import JobapplyCandidates from "../../../../components/Jobs_Candidates";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { FailedNotify, SuccessNotify } from "../../../../constants/tostify";
import { useGetJobsByCompanyQuery, useGetTotalPersonOnCompanyQuery, useDeleteJobMutation } from "../../../../features/user/userApiSlice";
import Loader from "../../../../components/Loader";
import SearchIcon from "@mui/icons-material/Search";
import dummyezi from "../../../../assets/images/dummy/dummyezi.png";
import { MainModal } from "@/components";

const Jobs = ({ id }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isloading, setIsloading] = useState(false);
  const [getJobdata, setGetJobdata] = useState([]);
  const [appliedJobdata, setappliedJobdata] = useState([]);
  const [index, setIndex] = useState();
  const [shows, setShows] = useState(false);
  const [show, setShow] = useState(0);
  const [currentPage, setCurrentPage] = useState(1); // Track current page
  const [dummyItems, setDummyItems] = useState(100); // Start with 100 dummy items
  const itemsPerPage = 50; // Limit to 50 items (getJobdata + dummy) per page

  // Define handleClose
  const handleClose = () => setIndex(0);

  // Calculate total items (getJobdata + dummy items) and pages
  const totalItems = Math.max(getJobdata?.length || 0, 100); // At least 100 items
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Calculate items to display for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = getJobdata?.slice(indexOfFirstItem, indexOfLastItem);
  const currentDummyCount = Math.max(0, 100 - (currentItems?.length || 0));

  const { data: jobsRes, isLoading: isJobsLoading } = useGetJobsByCompanyQuery(id, { skip: !id });
  const { data: personsRes, isLoading: isPersonsLoading } = useGetTotalPersonOnCompanyQuery(id, { skip: !id });
  const [deleteJobMutation] = useDeleteJobMutation();

  useEffect(() => {
    if (jobsRes?.success) {
      setGetJobdata(jobsRes?.data?.Jobs);
    }
  }, [jobsRes]);

  useEffect(() => {
    if (personsRes?.success) {
      setappliedJobdata(personsRes?.data);
    }
  }, [personsRes]);

  useEffect(() => {
    setIsloading(isJobsLoading || isPersonsLoading);
  }, [isJobsLoading, isPersonsLoading]);

  useEffect(() => {
    // Adjust number of dummy items based on getJobdata length
    setDummyItems(Math.max(0, 100 - (getJobdata?.length || 0))); // Total dummy items
  }, [getJobdata]);

  const Deletedata = async (e) => {
    setIsloading(true);
    try {
      const response = await deleteJobMutation(index).unwrap();
      if (response?.success) {
        setIsloading(false);
        SuccessNotify("Deleted Successfully!");
        setIndex(0);
        setTimeout(() => {
          navigate(`/company-profile/${id}`);
        }, 1000);
      }
    } catch (error) {
      setIsloading(false);
      setIndex(0);
      FailedNotify("Failed to Delete!");
    }
  };

  const handleSelect = (key) => {
    if (key === "Newjobs") {
      navigate(`/create-job/${id}`);
    }
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0); // Scroll to top on page change
  };

  // Combine getJobdata and dummy items
  const renderItems = () => {
    const renderedItems = [];

    // Add actual job items
    if (currentItems?.length > 0) {
      currentItems.forEach((jobs) => {
        renderedItems.push(
          <div key={jobs?._id}>
            <div className="company-job-row-scroll">
              <Row className="company-job-row">
                <Col>
                  <div>
                    <p className="mb-1 jobPara">Designation</p>
                    <h6 className="jobsDesc">{jobs?.title}</h6>
                  </div>
                </Col>
                <Col className="d-flex justify-content-center ps-0 ps-md-0">
                  <div>
                    <p className="mb-1 jobPara">Posted date</p>
                    <h6 className="jobsDesc">
                      {jobs?.createdAt.slice(0, 10)}
                    </h6>
                  </div>
                </Col>
                <Col className="d-flex justify-content-center p-0">
                  <div>
                    <p className="mb-1 jobPara">Last date of apply</p>
                    <h6 className="jobsDesc">{jobs?.duration}</h6>
                  </div>
                </Col>
                <Col className="d-flex justify-content-center ps-0">
                  <div>
                    <p className="mb-1 jobPara">View details</p>
                    <div className="d-flex justify-content-center">
                      <VisibilityIcon
                        className="viewBlue cursor_P"
                        onClick={() => navigate("/job-details/" + jobs?._id)}
                      />
                    </div>
                  </div>
                </Col>
                <Col className="d-flex justify-content-center ps-0">
                  <div>
                    <p className="mb-1 jobPara">Delete</p>
                    <div
                      className="d-flex justify-content-center"
                      onClick={() => {
                        setIndex(jobs?._id);
                      }}
                    >
                      <DeleteIcon className="deleteRed cursor_P" />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <hr className="m-0" />
          </div>
        );
      });
    }

    // Add dummy items with matching layout
    Array.from({ length: currentDummyCount }).forEach((_, index) => {
      renderedItems.push(
        <div key={`dummy-${index}-${indexOfFirstItem}`}>
          <div className="company-job-row-scroll">
            <Row className="company-job-row">
              <Col>
                <div>
                  <p className="mb-1 jobPara">Designation</p>
                  <h6 className="jobsDesc">Job posting to see here</h6>
                </div>
              </Col>
              <Col className="d-flex justify-content-center ps-0 ps-md-0">
                <div>
                  <p className="mb-1 jobPara">Posted date</p>
                  <h6 className="jobsDesc">&nbsp;</h6>
                </div>
              </Col>
              <Col className="d-flex justify-content-center p-0">
                <div>
                  <p className="mb-1 jobPara">Last date of apply</p>
                  <h6 className="jobsDesc">&nbsp;</h6>
                </div>
              </Col>
              <Col className="d-flex justify-content-center ps-0">
                <div>
                  <p className="mb-1 jobPara">View details</p>
                  <div className="d-flex justify-content-center">
                    <VisibilityIcon
                      className="viewBlue"
                      style={{ visibility: "hidden" }}
                    />
                  </div>
                </div>
              </Col>
              <Col className="d-flex justify-content-center ps-0">
                <div>
                  <p className="mb-1 jobPara">Delete</p>
                  <div className="d-flex justify-content-center">
                    <DeleteIcon
                      className="deleteRed"
                      style={{ visibility: "hidden" }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <hr className="m-0" />
        </div>
      );
    });

    return renderedItems;
  };

  return (
    <Col lg={12} md={12} style={{}}>
      <MainModal
          variant="deleteModal"
        show={index}
        title="Profile"
        handleClose={handleClose}
        handleDelete={Deletedata}
      />
      <Tabs
        defaultActiveKey="jobs"
        id="uncontrolled-tab-example"
        className="mb-3 ps-lg-2 ps-md-2 ps-sm-2 ps-2 groundset company-profile-tabs"
        onSelect={(k) => {
          handleSelect(k);
        }}
      >
        <Tab eventKey="jobs" title="Posted Jobs" className="jobviewhead">
          {isloading ? (
            <Loader heightsetting="scroll-company" />
          ) : (
            <div className="shops-container">
              <div className="scroll-company">
                {getJobdata?.length > 0 || currentDummyCount > 0 ? (
                  <>
                    {renderItems()}
                    {currentItems?.length === 0 && currentDummyCount === 0 && (
                      <h4 className="text-center">No jobs found</h4>
                    )}
                  </>
                ) : (
                  <h4 className="text-center">No jobs found</h4>
                )}
                {totalPages > 1 && (
                  <div className="d-flex justify-content-center mt-4">
                    <Pagination>
                      <Pagination.Prev
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                      />
                      {Array.from({ length: totalPages }, (_, index) => (
                        <Pagination.Item
                          key={index + 1}
                          active={index + 1 === currentPage}
                          onClick={() => handlePageChange(index + 1)}
                        >
                          {index + 1}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      />
                    </Pagination>
                  </div>
                )}
              </div>
            </div>
          )}
        </Tab>
        <Tab eventKey="Followers" title="Candidates Who Applied">
          <div className="noscroll ps-3 pe-3 company-profile-candidates">
           
            <JobapplyCandidates appliedJobdata={appliedJobdata} isloading={isloading} getJobdata={getJobdata} />
          </div>
        </Tab>
        <Tab eventKey="Newjobs" title="Post New Job" onSelect={handleSelect}></Tab>
      </Tabs>
    </Col>
  );
};

export default Jobs;